import React from "react";
import theme from "Theme/AppTheme";
import AcxMainTextField, {
    AcxMainTextFieldRef,
} from "components/UI/AcxMainTextField";
import { UserWithFullName } from "components/Signals/Dashboard/DashboardMenu/ShareDialog/constants";
import CommentComposerBase from "./CommentComposerBase";

type CommentComposerProps = {
    isChat: boolean;
    value: string;
    isSaving: boolean;
    commentTimestamp: string;
    inputRef: React.RefObject<AcxMainTextFieldRef>;
    onFocus: () => void;
    onChange: (
        event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
    ) => void;
    inputProps: React.ComponentProps<typeof AcxMainTextField>["inputProps"];
    onTimestampChange: (value: string) => void;
    onCancel: () => void;
    onSubmit: () => void;
    mentionDropdown: React.ReactNode;
    mentionSelections: UserWithFullName[];
};

const CommentComposer = ({
    isChat,
    value,
    isSaving,
    commentTimestamp,
    inputRef,
    onFocus,
    onChange,
    inputProps,
    onTimestampChange,
    onCancel,
    onSubmit,
    mentionDropdown,
    mentionSelections,
}: CommentComposerProps) => (
    <CommentComposerBase
        inputId="comment-composer-text-input"
        title="Add Comment"
        placeholderText="Comment or @ mention someone"
        value={value}
        inputRef={inputRef}
        onFocus={onFocus}
        onChange={onChange}
        inputProps={inputProps}
        mentionDropdown={mentionDropdown}
        mentionSelections={mentionSelections}
        actionJustify={isChat ? "flex-end" : "space-between"}
        onCancel={onCancel}
        onSubmit={onSubmit}
        primaryLabel={isSaving ? "Posting..." : "Post"}
        secondaryLabel="Cancel"
        primaryButtonId="post-comment"
        disablePrimary={!value.trim() || isSaving}
        disableSecondary={!value.trim() || isSaving}
        containerBackground={theme.palette.gray.light}
        inputBackground={theme.palette.gray[50]}
        showTimestamp={!isChat}
        timestampValue={commentTimestamp}
        onTimestampChange={onTimestampChange}
    />
);

export default CommentComposer;
